{
  "version": 1,
  "asset_id": "afc35a8f-af02-48c4-b584-902d01c2786e",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/afc35a8f-af02-48c4-b584-902d01c2786e/ss01-card-n5.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/afc35a8f-af02-48c4-b584-902d01c2786e/ss01-card-n5.webp",
  "original_filename": "ss01-card-n5.webp",
  "size": 114314,
  "content_type": "image/webp",
  "created_at": "2026-09-12T16:22:41Z"
}
